import Paragrafo from '../Paragrafo'
import { Card, LinkBotao } from '../Projeto/style'
import { Divisor, Titulos } from '../Projetos/styles'
import Title from '../Title'

export const Academico = () => (
  <Card>
    <Titulos>
      <Title>Challenge Scheneider Eletric</Title>
      <Divisor />
      <br />
      <Paragrafo>21/08/2023</Paragrafo>
    </Titulos>
    <Paragrafo tipo="secundario">
      Participação destacada em parceria com a Schneider Electric na criação de
      uma plataforma inovadora de conscientização sustentável para os
      colaboradores. Junto a uma equipe de 4 estudantes, concebendo e
      implementando plataforma interativa com feed, quiz e notícias.
      Contribuição significativa na construção do overview utilizando HTML, CSS3
      e Bootstrap, bem como na concepção da ideia e texto do vídeo pitch.
      Experiência colaborativa com foco em tecnologias-chave como HTML5, CSS3 e
      JavaScript.
    </Paragrafo>
    <Titulos>
      <LinkBotao
        href="https://github.com/victorcesae/global-solution"
        target="_blank"
      >
        Repositório
      </LinkBotao>
      <LinkBotao href="https://youtu.be/weHnUwrBtYo" target="_blank">
        Vídeo Pitch
      </LinkBotao>
    </Titulos>
  </Card>
)

export const Academico2 = () => (
  <Card>
    <Titulos>
      <Title>
        Global Solution - Combate à fome mundial e à escassez de alimentos
      </Title>
      <Divisor />
      <br />
      <Paragrafo>07/06/2023</Paragrafo>
    </Titulos>
    <Paragrafo tipo="secundario">
      Como membro de uma equipe de três alunos, contribuí para o projeto SACS -
      Agricultura Compartilhada Sustentável, com o objetivo de enfrentar a fome
      por meio da inovação. Criamos uma plataforma web dinâmica que aborda a
      questão da fome, apresentando nossa estratégia e utilizando HTML5, CSS3 e
      JavaScript, além do framework Tailwind para a estética. Fui fundamental na
      criação da seção de agricultura sustentável, desempenhando papel essencial
      na concepção da ideia e no texto pitch. Nossa colaboração abrangeu todas
      as fases, desde o conceito até a implementação da plataforma, incluindo a
      produção de vídeo.
    </Paragrafo>
    <Titulos>
      <LinkBotao
        href="https://github.com/victorcesae/challengeschneider.git"
        target="_blank"
      >
        Repositório
      </LinkBotao>
      <LinkBotao href="https://youtu.be/SGwgFb8-Zng" target="_blank">
        Vídeo Pitch
      </LinkBotao>
    </Titulos>
  </Card>
)

export const Academico3 = () => (
  <Card>
    <Titulos>
      <Title>Documentando casos de uso </Title>
      <Divisor />
      <br />
      <Paragrafo>10/08/2023</Paragrafo>
    </Titulos>
    <Paragrafo tipo="secundario">
      Desenvolvimento de caso de uso para app de pedido de pizza, abordando
      funcionalidades de pesquisa e registro de compra.
    </Paragrafo>
    <LinkBotao
      href="https://docs.google.com/document/d/1iXqa40WxEBDGABCzvFoJiGDezqTEb50KbfTyECCv9ZM/edit?usp=sharing"
      target="_blank"
    >
      Link
    </LinkBotao>
  </Card>
)

export const Academico4 = () => (
  <Card>
    <Titulos>
      <Title>Agrotech - Empreendimento inovador para Agricultura Local</Title>
      <Divisor />
      <br />
      <Paragrafo> 26/04/23</Paragrafo>
    </Titulos>
    <Paragrafo tipo="secundario">
      Raízes Locais - Durante minha graduação, concebi e desenvolvi um projeto
      que combina tecnologia e agricultura. Em parceria com um colega, criamos
      um protótipo de um aplicativo no Figma, que conecta pequenos produtores a
      mercados de difícil alcance. Meu envolvimento abrangeu desde a concepção
      até a construção, incluindo um vídeo pitch e uma apresentação detalhada.
    </Paragrafo>
    <LinkBotao
      href="https://www.figma.com/proto/o3w1qhDhHsmkKYIWzXqtJ7/raizes_locais?node-id=1-6&mode=design&t=lYMC0MXCnSOOD38C-1"
      target="_blank"
    >
      Link
    </LinkBotao>
  </Card>
)
